import styled from "styled-components";
import RowOption from '../rowOption.jsx'
import CountrySelect  from '../../countrySelect.jsx'
import SelectOption from '../selectOption.jsx'
import DeleteButton from'../deleteButton.jsx'
import { usuarioSelected } from '../../../redux/actions/usuarioActions.js';


const Container=styled.div`
	width:100%;
	display:flex;
	align-items:center;
	color:white;
`
const Info=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	align-items:center;
	margin-bottom:15px;
	padding:15px
`


export default function DetailInfoUser(props){
	
	let{ value,action,estado,url,paisSelected}=props;
	let data=[{label:"seleccionar...", value:0},{label:"superAdmin", value:1},{label:"administrador",value:2},{label:"cliente",value:3}];

	
	return(
		<Container>	
				
      				<h1>Detalle</h1>
 					<Info>	
 						<RowOption label="telefono" value={value.telefono} action={action} estado={estado} />
 					{estado!==0?<CountrySelect paisSelected={paisSelected} default={value.pais} fullwidth/>:
 						<RowOption label="pais" value={value.pais} action={action} estado={estado} />}
 					{estado!==0? 					
 						<SelectOption value={value.tipo} id={value.id} action={action} consolaIndice={value.tipo}  estado={estado} label="tipo"  data={data}/>:
 						<RowOption label="tipo" value={value.tipo===1?"administrativo":"cliente"} action={action}  estado={estado}  />}
 					
 					{estado===2?<DeleteButton iDlte={value.id} url={url} action={estado} selected={usuarioSelected({ id:"",name:"",usuario:"",password:"",tipo:0 })} />:null}
 												
 					</Info>


 				
 		</Container>

		)
}